import { Component, OnInit, ViewChild, ChangeDetectorRef, OnDestroy, OnChanges, SimpleChanges, EventEmitter, Input, Output } from '@angular/core';
import { DataService } from '../../shared/dataservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SalesOrder, SaveStatusObj, SOModule, SaveEventType, SOStatus, MarketingIP, PmCommercialIP, SubSalesOrder, SSOStatus, FunctionStatus, fileManagerObject, SpecialPriceFile, PlannedDateToken, ActualDateToken, Deletereason, RetentionPayment, SpecialPoint, ServerSockEvent, ValidationItem, ValidationSummary, GenFileUploads, UserType, DataSheetIP, DataSheetSubOrderIP, DatasheetNumbers } from '../../shared/misc-classes';
import { MatStepper } from '@angular/material/stepper';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { SaveConfirmDialog } from '../../dialogs/save-confirm-dialog/save-confirm-dialog';
import { DeleteConfirmDialog } from '../../dialogs/delete-confirm-dialog/delete-confirm-dialog';
import { GenService } from '../../shared/gen-ser.service';
import { RevisionHandlerService } from '../../shared/revision-handler.service';
import { Subscription } from 'rxjs';
import { SubSalesorderComponent } from './sub-salesorder/sub-salesorder.component';
import { FileUploadDialog } from '../../dialogs/file-upload-dialog/file-upload-dialog';
//import { SOGanttViewerDialog } from '../../dialogs/so-gantt-viewer-dialog/so-gantt-viewer-dialog';
import { ValidationDialog } from '../../dialogs/validation-dialog/validation-dialog';
import { ProcessFailDialog } from '../../dialogs/process-fail-dialog/process-fail-dialog';

@Component({
  selector: 'app-edit-sales-order',
  templateUrl: './edit-sales-order.component.html',
  styleUrls: ['./edit-sales-order.component.css'],
  //changeDetection:ChangeDetectionStrategy.OnPush
})
export class EditSalesOrderComponent implements OnInit, OnDestroy {

  salesOderId!: string;
  //soLockFailed:boolean = false;
  landingPage: string = "";
  soObj!: SalesOrder;
  soObj_temp: any;  // Stores JSON snapshot of sales order for change detection
  soObjDel!: SalesOrder;
  subSoNo: number = 0;
  isLoaded: boolean = false;
  private getUrlId!: Subscription;
  private eventSubscription!: Subscription;
  //inputData:any;
  isLockObtained: boolean = false;
  lastLockCheck!: Date;
  DSList: Array<DataSheetIP> = [];

  @ViewChild('stepper', { static: false })
  stepper!: MatStepper;
  //@ViewChild('ganttModal') ganttModal: ModalDirective;
  @ViewChild(SubSalesorderComponent, { static: false })
  subSaleOrder!: SubSalesorderComponent;

  private _pendingMainStepIndex: number | null = null;

  constructor(private ref: ChangeDetectorRef, private _dataService: DataService, private route: ActivatedRoute, public dialog: MatDialog, private router: Router, private _revisionHandler: RevisionHandlerService) { }

  ngOnInit() {
    this._dataService.maxSelDate = new Date();
    this._dataService.getDataDefinitions().subscribe(res => {
      this.getUrlId = this.route.params.subscribe(params => {
        this.salesOderId = params['soid'];
        this.landingPage = params['somodule'];
        this.subSoNo = params['subsono'];
        this.loadSalesOrderData();
      });
    });
  }

  private getEditingUserNames(_data: any): string {
    if (_data.users) {
      let _retVal: string = '';
      for (var i = 0; i < _data.users.length; i++) {
        _retVal += (_retVal != '' ? ', ' : '') + GenService.extractNameFromEmail(_data.users[i])
      }
      return _retVal;
    }
    return '';
  }

  ngOnDestroy() {
    this._dataService.releaseSOLock(this.salesOderId).subscribe((_result) => { });

    if (this.getUrlId) {
      this.getUrlId.unsubscribe();
    }

    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }

  }


  outputfromAngular1(outPutData: string) {
    alert(outPutData);
  }


  private initNewSalesOrder() {
    let RetPayCon: RetentionPayment = new RetentionPayment(null, null);
    let RetPayConList: Array<RetentionPayment> = [];
    RetPayConList.push(RetPayCon);


    let marketingObj: MarketingIP = new MarketingIP("", "inbp", "", "", "", "", "", "", null, "", null, "", "", "", "", "",
      new SpecialPoint('', []), "",
      null, 0, null, null, "", 0,
      "", "", "", "", "", "", "", null, "", "", "", "", null, null, "", null, null, RetPayConList,
      "", new SpecialPriceFile([]),
      new PlannedDateToken(null, false, null, '', ''),
      new PlannedDateToken(null, false, null, '', ''),
      new PlannedDateToken(null, false, null, '', ''),
      new ActualDateToken(null, false, null, '', ''),
      new ActualDateToken(null, false, null, '', ''),
      new ActualDateToken(null, false, null, '', ''),
      null, null, null, null,
      // SAP Fields
      "", "", "", "", "", "", "", "", "", "", "", false,
      FunctionStatus.WAITING_FOR_USER_INPUT);
    let dataSheetObj: Array<DataSheetIP> = [];

    let pmCommercialObj: PmCommercialIP = new PmCommercialIP("", "", null, null, null,
      null, new GenFileUploads([]), new PlannedDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
      new PlannedDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
      null, new GenFileUploads([]), new PlannedDateToken(null, false, null, '', ''), null, new ActualDateToken(null, false, null, '', ''),
      new PlannedDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
      null, new PlannedDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
      new PlannedDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''), "no", null, "", null, null, "", [],
      FunctionStatus.WAITING_FOR_PREV);

    let subSalesOrderList: Array<SubSalesOrder> = [];

    this.soObj = new SalesOrder(GenService.getGUID(), marketingObj, dataSheetObj, pmCommercialObj, subSalesOrderList, SOStatus.Marketing, 0);
    this.isLoaded = true;
    this.isLockObtained = true;
    //this.inputData = this.soObj.marketingIP;
    //this.ref.markForCheck();
  }

  private loadSalesOrderFromDB() {
    // this.soLockFailed = false;
    this._dataService.getSalesOrder(this.salesOderId).subscribe((_tmpSalesOrder: SalesOrder) => {
      this.soObj = _tmpSalesOrder;
      // console.log("SSO",this.soObj);
      // FOR LOGS
      const a = this.soObj.cloneSelf();
      this.soObj_temp = JSON.parse(JSON.stringify(a.getJson()));
      // END LOGS

      //console.log("this._dataService.additionalPageDetails::",this._dataService.additionalPageDetails)
      this._dataService.additionalPageDetails = this.soObj.getProjDetails();
      // console.log("this._dataService.additionalPageDetails::",this._dataService.additionalPageDetails)
      setTimeout(() => {
        //this.soObj = _tmpSalesOrder;
        this.isLoaded = true;
        if (this.applyPendingMainStepIndex()) {
          return;
        }

        if (this.landingPage == null) {
          switch (this.soObj.projectStatus) {
            case SOStatus.Marketing:
              this.landingPage = "marketing";
              break;
            case SOStatus.PM_Commercial:
              this.landingPage = "pmcommercial";
              break;
            // case SOStatus.PM_Tech:
            //   this.landingPage = "pmTech";
            //   break;
            case SOStatus.Sub_Orders:
              this.landingPage = "sso";
              break;
            default:
              this.landingPage = "marketing";
              break;

          }
        }


        switch (this.landingPage) {
          case "marketing":
            this.stepper.selectedIndex = 0;
            break;
          case "pmcommercial":
            this.stepper.selectedIndex = this.soObj.dataSheetIP.length + 2;
            // this.stepper.selectedIndex = 1;
            break;
          // case "pmTech":
          //   this.stepper.selectedIndex = 2;
          //   break;
          case "sso":
            this.stepper.selectedIndex = this.soObj.dataSheetIP.length + 3;
            // this.stepper.selectedIndex = 2;
            break;
          default:
            this.stepper.selectedIndex = this.soObj.dataSheetIP.length + 3;
            // this.stepper.selectedIndex = 2;
            break;
        }
      }
        , 0);

      this.editSalesOrderLock();


    });
  }

  // editLockTimer:any;
  private editSalesOrderLock() {
    this._dataService.getSOLock(this.salesOderId).subscribe((_result) => {
      this.lastLockCheck = new Date();
      if (_result.status == "OK") {
        this.isLockObtained = true;
      }
      else if (_result.status == "LOCKED") {
        this.isLockObtained = false;

        let _validList: Array<ValidationItem> = [];
        _validList.push(new ValidationItem("This Sale Order is being locked by " + GenService.extractNameFromEmail(_result.user), false,
          "\r\n You cannot make any changes until lock is released."));

        let vSummaryObj: ValidationSummary = new ValidationSummary("Sale Order Locked.", _validList);
        this.dialog.open(ValidationDialog, {
          width: '50%',
          data: vSummaryObj
        });
      }
    });
    // if(this.editLockTimer != null){
    //   clearTimeout(this.editLockTimer);
    // }
    // if(this.soLockFailed == false){
    //   if(this._dataService.isSocketEnabled == true){
    //     this._dataService.triggerServerEvent('editsaleorder',{"soid":this.salesOderId});

    //     this.editLockTimer = setTimeout(() => {
    //       this.editSalesOrderLock();
    //     }, 5000);
    //   }
    // }
  }
  private loadSalesOrderData() {
    this.isLockObtained = false;
    if (this.salesOderId == null) {
      setTimeout(() => this._dataService.currPageName = 'New Sales Order');
      this.initNewSalesOrder();
    }
    else {
      setTimeout(() => this._dataService.currPageName = 'Edit Sales Order');
      this.loadSalesOrderFromDB();
    }
  }
  startGenFileManager(_evnt: GenFileUploads) {
    let _widthPer: number = 80;
    let _header: string = _evnt.headerStr;

    let dialogRef = this.dialog.open(FileUploadDialog, {
      width: _widthPer + '%',
      data: { message: "message", header: _header, files: _evnt.FileArray, readAccess: _evnt.disableUpload }
    });
  }

  startFileManager(_evnt: SpecialPoint) {
    let _widthPer: number = 80;
    let _header: string = '-'
    //if(_evnt.source == 'spl_point'){
    _header = "Special Point";
    //}

    let dialogRef = this.dialog.open(FileUploadDialog, {
      width: _widthPer + '%',
      data: { message: "message", header: _header, files: _evnt.FileArray, readAccess: _evnt.readOnly }
    });
  }
  startSpecialPriceFileManager(_evnt: SpecialPriceFile) {
    let _widthPer: number = 80;
    let _header: string = '-'
    //if(_evnt.source == 'spl_point'){
    _header = "Special Price File";
    //}

    let dialogRef = this.dialog.open(FileUploadDialog, {
      width: _widthPer + '%',
      data: { message: "message", header: _header, files: (_evnt ? _evnt.FileArray : []), readAccess: _evnt.readOnly }
    });
  }
  openSOGanttChart(_evnt: any) {
    //this.ganttModal.show();
    // let _widthPer:number = 80;
    // let _header:string = '-'

    // let dialogRef = this.dialog.open(SOGanttViewerDialog, {
    //   width: _widthPer + '%',
    //   data: { message: "message", header:_header }
    // });
  }
  hideGanttModal() {
    //this.ganttModal.hide()
  }

  updateSalesOrder(_evnt: SaveStatusObj) {
    if (_evnt.eventType == SaveEventType.Reload_Data)//reload form
    {
      this.captureUiContext();
      this.loadSalesOrderData();
    }
    else if (_evnt.eventType == SaveEventType.Save_Data)//save the form
    {
      this.captureUiContext();
      this.saveSalesOrderToDB(_evnt, "Do you want to save the Sales Order ?", 400);
    }
    else if (_evnt.eventType == SaveEventType.Submit_To_Next)//submit to next section
    {
      this.submitSalesOrderToNextSection(_evnt);
    }
    else if (_evnt.eventType == SaveEventType.Delete_Sale_Order) {
      this.deleteSaleOrder(_evnt, "Do you want to delete sales order?", 400);
    }
    else if (_evnt.eventType == SaveEventType.Delete_SubSale_Order) {
      this.deleteSubSaleOrder(_evnt, "Do you want to delete sales order?", 400);
    }
    else if (_evnt.eventType == SaveEventType.Save_ChangeData)//save the form
    {
      this.captureUiContext();
      this.saveSalesOrderToDB_2();
    }
    else if (_evnt.eventType == SaveEventType.Delete_Datasheet)//save the form
    {
      this.deleteDatasheet(_evnt, "Do you want to delete Datasheet?", 400);
    }
  }

  private captureUiContext(): void {
    this._pendingMainStepIndex = (this.stepper && typeof this.stepper.selectedIndex === 'number')
      ? this.stepper.selectedIndex
      : 0;
  }

  private applyPendingMainStepIndex(): boolean {
    if (this._pendingMainStepIndex == null || !this.stepper || !this.soObj) {
      return false;
    }

    const maxStepIndex = this.soObj.dataSheetIP.length + 3;
    const targetMainIndex = Math.max(0, Math.min(this._pendingMainStepIndex, maxStepIndex));

    this.stepper.selectedIndex = targetMainIndex;
    this._pendingMainStepIndex = null;
    return true;
  }

  submitSalesOrderToNextSection(_evnt: SaveStatusObj) {
    if (this.validateSubmitData(_evnt) == true) {
      var preExecStep = null;
      switch (_evnt.source) {
        case SOModule.Marketing:
          preExecStep = () => {
            this.soObj.projectStatus = SOStatus.PM_Commercial;
            this.landingPage = null;
          };
          this.saveSalesOrderToDB(_evnt, "<div class='red-text'>Do you want to submit to PM Commercial ?</div>", 400, preExecStep);
          break;
        case SOModule.PM_Commercial:
          preExecStep = () => {
            this.soObj.projectStatus = SOStatus.Sub_Orders;
            this.landingPage = null;
          };
          this.saveSalesOrderToDB(_evnt, "<div class='red-text'>Do you want to submit to PM Technical ?</div>", 400, preExecStep);
          break;
        case SOModule.Sub_Orders:
          this.submitSSOToNextSection(_evnt);
          break;
      }

    }
  }


  submitSSOToNextSection(_evnt: SaveStatusObj) {
    var preExecStep = null;
    switch (_evnt.ssoSubmitTo) {
      case SSOStatus.Engg_Draw:
        preExecStep = () => {
          this.soObj.subSalesOrder[_evnt.ssoIndex].enableEnggDrawInput();
        };
        this.saveSalesOrderToDB(_evnt, "<div class='red-text'>Do you want to submit to Engineering Drawing ?</div>", 400, preExecStep);
        break;
      case SSOStatus.SCM:
        preExecStep = () => {
          this.soObj.subSalesOrder[_evnt.ssoIndex].enableSCMInput();
        };
        this.saveSalesOrderToDB(_evnt, "<div class='red-text'>Do you want to submit to SCM ?</div>", 400, preExecStep);
        break;
      case SSOStatus.PM_Tech_EnggDraw:
        preExecStep = () => {
          this.soObj.subSalesOrder[_evnt.ssoIndex].enablePMTechInputFromEnggDraw();
        };
        this.saveSalesOrderToDB(_evnt, "<div class='red-text'>Do you want to submit to PM-Tech and SCM ?</div>", 400, preExecStep);
        break;
      case SSOStatus.Planning_From_PMTech:
        preExecStep = () => {
          this.soObj.subSalesOrder[_evnt.ssoIndex].enablePlanningInputFromPMTech();
        };
        this.saveSalesOrderToDB(_evnt, "<div class='red-text'>Do you want to enable Planning?</div>", 400, preExecStep);
        break;
      case SSOStatus.Engg_Procurement_From_EnggDraw:
        preExecStep = () => {
          this.soObj.subSalesOrder[_evnt.ssoIndex].enableEnggProcurementInputFromEnggDraw();
        };
        this.saveSalesOrderToDB(_evnt, "<div class='red-text'>Do you want to submit to Engg Procurement ?</div>", 400, preExecStep);
        break;
      case SSOStatus.Engg_Procurement_From_SCM:
        preExecStep = () => {
          this.soObj.subSalesOrder[_evnt.ssoIndex].enableEnggProcurementInputFromSCM();
        };
        this.saveSalesOrderToDB(_evnt, "<div class='red-text'>Do you want to submit to Engg Procurement ?</div>", 400, preExecStep);
        break;
      case SSOStatus.PO | SSOStatus.Planning:
        preExecStep = () => {
          this.soObj.subSalesOrder[_evnt.ssoIndex].enablePOPlanningInputFromProc();
        };
        this.saveSalesOrderToDB(_evnt, "<div class='red-text'>Do you want to submit to PO & Planning?</div>", 400, preExecStep);
        break;
      case SSOStatus.Planning_From_PO:
        preExecStep = () => {
          this.soObj.subSalesOrder[_evnt.ssoIndex].enablePlanningInputFromProc();
        };
        this.saveSalesOrderToDB(_evnt, "<div class='red-text'>Do you want to submit to Planning?</div>", 400, preExecStep);
        break;
      case SSOStatus.Material_Receipt | SSOStatus.Store | SSOStatus.Production:
        preExecStep = () => {
          this.soObj.subSalesOrder[_evnt.ssoIndex].enableMRSPInputFromProc();
        };
        this.saveSalesOrderToDB(_evnt, "<div class='red-text'>Do you want to submit to Material Receipt, Store & Production ?</div>", 400, preExecStep);
        break;
      case SSOStatus.Production_From_Store:
        preExecStep = () => {
          this.soObj.subSalesOrder[_evnt.ssoIndex].enableProductionFromStore();
        };
        this.saveSalesOrderToDB(_evnt, "<div class='red-text'>Do you want to submit to Production ?</div>", 400, preExecStep);
        break;
      case SSOStatus.Store_From_MaterialReceipt:
        preExecStep = () => {
          this.soObj.subSalesOrder[_evnt.ssoIndex].enableStoreInputFromMaterialReceipt();
        };
        this.saveSalesOrderToDB(_evnt, "<div class='red-text'>Do you want to submit to Store ?</div>", 400, preExecStep);
        break;
      case SSOStatus.Quality:
        preExecStep = () => {
          this.soObj.subSalesOrder[_evnt.ssoIndex].enableQualityInputFromProduction();
        };
        this.saveSalesOrderToDB(_evnt, "<div class='red-text'>Do you want to submit to Testing?</div>", 400, preExecStep);
        break;
      case SSOStatus.Logistic:
        preExecStep = () => {
          this.soObj.subSalesOrder[_evnt.ssoIndex].enableLogisticInputFromQuality();
        };
        this.saveSalesOrderToDB(_evnt, "<div class='red-text'>Do you want to submit to Logistic?</div>", 400, preExecStep);
        break;

      case SSOStatus.Dispatched:
        preExecStep = () => {
          this.soObj.subSalesOrder[_evnt.ssoIndex].enableSubOrderCompletion();
        };
        this.saveSalesOrderToDB(_evnt, "<div class='red-text'>Do you want to Submit Sub Order Completion?</div>", 400, preExecStep);
        break;
      case SSOStatus.UnDispatched:
        preExecStep = () => {
          this.soObj.subSalesOrder[_evnt.ssoIndex].enableUndispatchedFromLogistic();
        };
        this.saveSalesOrderToDB(_evnt, "<div class='red-text'>Do you want to Bring Old Orders Back?</div>", 400, preExecStep);
        break;
      case SSOStatus.PM_Tech_EnggDraw | SSOStatus.SCM:
        preExecStep = () => {
          this.soObj.subSalesOrder[_evnt.ssoIndex].enablePMTechScmInputFromEnggDraw();
        };
        this.saveSalesOrderToDB(_evnt, "<div class='red-text'>Do you want to submit to PM Tech & SCM?</div>", 400, preExecStep);
        break;
      case SSOStatus.Engg_Procurement_From_PM_Tech | SSOStatus.Logistic_From_PM_Tech:
        preExecStep = () => {
          this.soObj.subSalesOrder[_evnt.ssoIndex].enableEnggProcLogisticInputFromPMTech();
        };
        this.saveSalesOrderToDB(_evnt, "<div class='red-text'>Do you want to submit to Engg Procurement & Logistic ?</div>", 400, preExecStep);
        break;

      default:
        alert('error in edit sales order line 287->' + _evnt.ssoSubmitTo);

        break;

    }
  }

  validateSubmitData(_evnt: SaveStatusObj) {



    return true;
  }

  saveSalesOrderToDB(_evnt: SaveStatusObj, _message: string, _width: number = 250, preExecStep = null) {

    console.log("SO BEFORE SAVE:", this.soObj);
    // FOR LOGS
    var basicData = [];
    if (this.soObj_temp && this.soObj) {
      var a = this.changesFunc(this.soObj_temp, this.soObj, basicData);
      var dateNow = new Date();
      var formattedDate = dateNow.getDate() +
        // "-"+(dateNow.getMonth()+1)+
        "-" + (dateNow.getMonth() < 10 ? '0' : '') + (dateNow.getMonth() + 1) +
        "-" + dateNow.getFullYear() +
        " " + dateNow.getHours() +
        ":" + (dateNow.getMinutes() < 10 ? '0' : '') + dateNow.getMinutes() +
        ":" + dateNow.getSeconds();

      var logData: string = '';
      if (a.length != 0) {
        for (let i = 0; i < a.length; i++) {
          var temp = formattedDate + " | " + this._dataService.userId + " | " + UserType[this._dataService.userType] + " | " + basicData[0] + " | " + basicData[1] + " ::: " + a[i] + "\r\n";
          logData = logData.concat(temp);
        }
      }
      else logData = formattedDate + " | " + this._dataService.userId + " | " + UserType[this._dataService.userType] + " | " + basicData[0] + " | " + basicData[1] + " ::: Saved Sub Order" + "\r\n";

      var _fname = this._dataService.userId;
      var _fId = _fname.split('@');
      var _fId1 = _fId[0].replace('.', '-');

      var _logFile = { "name": _fId1, "data": logData };


      this._dataService.logFile(_logFile).subscribe((respData: any) => {

        if (respData.status == "OK") {

        }
      });
    }
    // END LOGS
    if (this.clientValidation() == false) {
      return;
    }
    let dialogRef = this.dialog.open(SaveConfirmDialog, {
      width: _width + 'px',
      data: { message: _message }
    });

    dialogRef.afterClosed().subscribe((confirm) => {
      //this.soObj.changeCounter = this.soObj.changeCounter +1;
      if (confirm == true) {
        if (preExecStep != null) {
          preExecStep();
        }

        if (this.soObj.subSalesOrder.length > 0) {
          var isSaleOrderDispatched: boolean = true;
          for (var i = 0; i < this.soObj.subSalesOrder.length; i++) {
            if (this.soObj.subSalesOrder[i].isSSOStatusSet(SSOStatus.Dispatched) == false) {
              isSaleOrderDispatched = false;
              break;
            }
          }
          if (isSaleOrderDispatched == true) {
            this.soObj.projectStatus = SOStatus.Dispatched;
          }
          else {
            this.soObj.projectStatus = SOStatus.Sub_Orders;
          }

          if (this.soObj.projectStatus == SOStatus.Dispatched) {
            if (this.soObj.isDataFilledCompletely() == true) {
              this.soObj.projectStatus = SOStatus.Archived;
            }
          }
        }

        // Dump datasheet revision before save
        this.dumpDatasheetRevisions();

        this._dataService.saveSalesOrder(this.soObj).subscribe((respData: any) => {
          if (respData.status == "OK") {
            this.salesOderId = respData.so_id;
            this._dataService.openSnackbar("Status", "SUCCESS");

            // Create datasheet version snapshots after successful save
            this.createDatasheetVersionSnapshots();

            this.loadSalesOrderData();
          }
          else if (respData.status == "FAIL" && respData.error == "012") {
            this.displayStaleDataMessage(respData.updateUser, respData.updateTime);
          }
          else if (respData.status == "FAIL" && respData.error == "013") {
            this.displayInvalidSONumber();
          }
          else if (respData.status == "FAIL" && respData.error == "014") {
            this.displaySONumberTaken();
          }
          else
            this._dataService.openSnackbar("Status", "FAILED");
        });
      }
      else {
        //user didn't accepted
      }
    });
  }
  saveSalesOrderToDB_2() {

    if (this.clientValidation() == false) {
      return;
    }
    if (this.soObj.subSalesOrder.length > 0) {
      var isSaleOrderDispatched: boolean = true;
      for (var i = 0; i < this.soObj.subSalesOrder.length; i++) {
        if (this.soObj.subSalesOrder[i].isSSOStatusSet(SSOStatus.Dispatched) == false) {
          isSaleOrderDispatched = false;
          break;
        }
      }
      if (isSaleOrderDispatched == true) {
        this.soObj.projectStatus = SOStatus.Dispatched;
      }
      else {
        this.soObj.projectStatus = SOStatus.Sub_Orders;
      }

      if (this.soObj.projectStatus == SOStatus.Dispatched) {
        if (this.soObj.isDataFilledCompletely() == true) {
          this.soObj.projectStatus = SOStatus.Archived;
        }
      }
    }

    this._dataService.saveSalesOrder(this.soObj).subscribe((respData: any) => {
      if (respData.status == "OK") {
        this.salesOderId = respData.so_id;
        this._dataService.openSnackbar("Status", "SUCCESS");

        this.loadSalesOrderData();
      }
      else if (respData.status == "FAIL" && respData.error == "012") {
        this.displayStaleDataMessage(respData.updateUser, respData.updateTime);
      }
      else if (respData.status == "FAIL" && respData.error == "013") {
        this.displayInvalidSONumber();
      }
      else if (respData.status == "FAIL" && respData.error == "014") {
        this.displaySONumberTaken();
      }
      else
        this._dataService.openSnackbar("Status", "FAILED");
    });
  }
  private clientValidation(): boolean {
    if (this.soObj.marketingIP.isSalesOrderNoValid == false) {
      this.displayInvalidSONumber();
      return false;
    }
    return true;
  }

  private _pendingVersionUploads: Array<{ path: string, content: string }> = [];

  private dumpDatasheetRevisions() {
    if (!this.soObj || !this.soObj.subSalesOrder) return;
    this._pendingVersionUploads = [];

    // Build lookup by sub-order id to avoid index coupling and ensure per-sub-order isolation.
    // soObj_temp is JSON (from getJson()), which uses 'subOrdrs' not 'subSalesOrder'
    const savedBySubOrderId: { [subOrderNoId: string]: any } = {};
    if (this.soObj_temp && this.soObj_temp.subOrdrs) {
      for (const savedSub of (this.soObj_temp.subOrdrs as any[])) {
        if (savedSub && savedSub.subOrdNoId) {
          savedBySubOrderId[savedSub.subOrdNoId] = savedSub.dataSheetSubOrderIP || null;
        }
      }
    }

    for (let i = 0; i < this.soObj.subSalesOrder.length; i++) {
      let sso = this.soObj.subSalesOrder[i];
      let ds = sso.dataSheetSubOrderIP;
      if (!ds) continue;

      // Defensive de-sharing: if the same datasheet object instance is accidentally shared
      // across sub-orders, clone this sub-order's datasheet before mutating revisions.
      const firstSameRefIdx = this.soObj.subSalesOrder.findIndex((x, idx) => idx !== i && x && x.dataSheetSubOrderIP === ds);
      if (firstSameRefIdx >= 0) {
        const isolatedDs = DataSheetSubOrderIP.getObj(ds.getJson());
        isolatedDs.parentSORef = sso.parentSORef;
        isolatedDs.parentSubSORef = sso;
        sso.dataSheetSubOrderIP = isolatedDs;
        ds = isolatedDs;
      }

      // Get the saved snapshot for this exact sub-order id for change detection.
      let savedDsJson = savedBySubOrderId[sso.subOrderNoId] || null;
      let currentDsJson = ds.getJson();

      if (!this._revisionHandler.hasDatasheetChanged(currentDsJson, savedDsJson)) {
        continue;
      }

      let useAlpha = this._revisionHandler.isAlphabeticRevision(sso);
      let nextVersion = this._revisionHandler.getNextRevisionNumber(ds.currentVersion, useAlpha);
      let blobPath = this._revisionHandler.generateVersionPath(
        this.soObj.marketingIP.salesOrderNo, sso.subOrderNoId, ds.currentVersion
      );
      let deltaPath = this._revisionHandler.generateDeltaPath(
        this.soObj.marketingIP.salesOrderNo, sso.subOrderNoId, ds.currentVersion
      );
      const fieldDeltas = this._revisionHandler.buildRevisionChanges(
        savedDsJson || {},
        currentDsJson || {},
        ds.currentVersion,
        this._dataService.userName || '',
        new Date()
      );
      // Field-level deltas are persisted as a separate blob (see queue below).
      let versionEntry = this._revisionHandler.createVersionEntry(
        ds.currentVersion,
        blobPath,
        deltaPath,
        this._dataService.userId,
        this._dataService.userName,
        new Date()
      );
      ds.versions.push(versionEntry);
      ds.currentVersion = nextVersion;
      // currentDsJson is the definitive state at the moment of revision archival.
      this._pendingVersionUploads.push({
        path: blobPath,
        content: JSON.stringify(currentDsJson)
      });
      this._pendingVersionUploads.push({
        path: deltaPath,
        content: JSON.stringify(fieldDeltas)
      });
    }
  }

  private createDatasheetVersionSnapshots() {
    if (!this._pendingVersionUploads || this._pendingVersionUploads.length == 0) return;
    let queued = this._pendingVersionUploads;
    this._pendingVersionUploads = [];
    for (const p of queued) {
      this._dataService.createDatasheetVersion(
        p.path,
        p.content
      ).subscribe();
    }
  }

  displaySONumberTaken() {
    let _vItem: ValidationItem = new ValidationItem("Save Failed", false, " The Sale Order Number is already used, You cannot duplicate Sale Order Number.");

    this.dialog.open(ProcessFailDialog, {
      width: '50%',
      data: _vItem
    });
  }
  displayInvalidSONumber() {
    let _vItem: ValidationItem = new ValidationItem("Save Failed", false, " The Sale Order Number should be 10 digit number, Please correct it and try again .");

    this.dialog.open(ProcessFailDialog, {
      width: '50%',
      data: _vItem
    });
  }
  displayStaleDataMessage(_updUserMail: string, _updTime: number) {
    let uUserName: string = GenService.extractNameFromEmail(_updUserMail);
    let _vItem: ValidationItem = new ValidationItem("Save Failed", false, " The Sale Order is saved by \"" + uUserName +
      "\" while you were editing it, \r\nPlease reload & make your changes again.");

    this.dialog.open(ProcessFailDialog, {
      width: '50%',
      data: _vItem
    });
  }

  deleteSaleOrder(_evnt: SaveStatusObj, _messagse: string, _width: number = 250, preExecStep = null) {
    let delReason: Deletereason = new Deletereason("");
    let dialogRef = this.dialog.open(DeleteConfirmDialog, {
      width: _width + 'px',
      data: delReason
    });
    dialogRef.afterClosed().subscribe((confirm) => {
      //this.soObj.changeCounter = this.soObj.changeCounter +1;
      if (confirm == true) {
        if (preExecStep != null) {
          preExecStep();
        }
        this._dataService.deleteSalesOrder(this.soObj, delReason.comments).subscribe((_result: boolean) => {
          if (_result == true) {
            this._dataService.openSnackbar("Status", "SUCCESS");

            setTimeout(() => {
              this.router.navigate(["/"])
            }, 500);
            //this.loadSalesOrderData();
          }
          else
            this._dataService.openSnackbar("Status", "FAILED");
        });
      }
      else {
        //user didn't accepted
      }
    });
  }
  deleteSubSaleOrder(_evnt: SaveStatusObj, _messagse: string, _width: number = 250, preExecStep = null) {
    let delReason: Deletereason = new Deletereason("");
    let dialogRef = this.dialog.open(DeleteConfirmDialog, {
      width: _width + 'px',
      // data: { message: _messagse }
      data: delReason
    });
    dialogRef.afterClosed().subscribe((confirm) => {
      //this.soObj.changeCounter = this.soObj.changeCounter +1;
      if (confirm == true) {
        if (preExecStep != null) {
          preExecStep();
        }
        var a = this.soObj.cloneSelf();
        this.soObjDel = a;
        this.soObjDel.subSalesOrder = this.soObj.subSalesOrder.splice(_evnt.ssoIndex, 1);

        // this.soObj.subSalesOrder.splice(_evnt.ssoIndex,1);
        // this._dataService.saveSalesOrder(this.soObj).subscribe((respData:any) => {
        this._dataService.deleteSubSalesOrder(this.soObj, this.soObjDel, delReason.comments).subscribe((respData: any) => {
          if (respData.status == "OK") {
            this.salesOderId = respData.so_id;
            this._dataService.openSnackbar("Status", "SUCCESS");

            this.loadSalesOrderData();
          }
          else if (respData.status == "FAIL" && respData.error == "012") {
            this.displayStaleDataMessage(respData.updateUser, respData.updateTime);
          }
          else
            this._dataService.openSnackbar("Status", "FAILED");
        });
      }
      else {
        //user didn't accepted
      }
    });
  }

  deleteDatasheet(_evnt: SaveStatusObj, _messagse: string, _width: number = 250, preExecStep = null) {
    let delReason: Deletereason = new Deletereason("");
    let dialogRef = this.dialog.open(DeleteConfirmDialog, {
      width: _width + 'px',
      // data: { message: _messagse }
      data: delReason
    });
    dialogRef.afterClosed().subscribe((confirm) => {
      //this.soObj.changeCounter = this.soObj.changeCounter +1;
      if (confirm == true) {
        if (preExecStep != null) {
          preExecStep();
        }
        var a = this.soObj.cloneSelf();
        this.soObjDel = a;
        this.soObjDel.dataSheetIP = this.soObj.dataSheetIP.splice(_evnt.ssoIndex, 1);

        // this.soObj.subSalesOrder.splice(_evnt.ssoIndex,1);
        // this._dataService.saveSalesOrder(this.soObj).subscribe((respData:any) => {
        this._dataService.deleteDatasheet(this.soObj, this.soObjDel, delReason.comments).subscribe((respData: any) => {
          if (respData.status == "OK") {
            this.salesOderId = respData.so_id;
            this._dataService.openSnackbar("Status", "SUCCESS");

            this.loadSalesOrderData();
          }
          else if (respData.status == "FAIL" && respData.error == "012") {
            this.displayStaleDataMessage(respData.updateUser, respData.updateTime);
          }
          else
            this._dataService.openSnackbar("Status", "FAILED");
        });
      }
      else {
        //user didn't accepted
      }
    });
  }

  getStatusCSS(_status: FunctionStatus): string {
    if (_status == FunctionStatus.WAITING_FOR_PREV) {
      return "tab-legend white-legend";
    }
    if (_status == FunctionStatus.WAITING_FOR_USER_INPUT) {
      return "tab-legend grey-legend";
    }
    if (_status == FunctionStatus.SUBMITTED_INCOMPLETE) {
      return "tab-legend yellow-legend";
    }
    if (_status == FunctionStatus.SUBMITTED_COMPLETE) {
      return "tab-legend green-legend";
    }
    if (_status == FunctionStatus.SUBMITTED_WAITING_RESPONSE) {
      return "tab-legend blue-legend";
    }
    if (_status == FunctionStatus.NOT_SUBMITTED_BUT_READY) {
      return "tab-legend yellow-legend";
    }
    return "tab-legend white-legend";
  }

  editSalesClick() {
    if (this.isLockObtained == true && this.lastLockCheck) {
      var _currTime = new Date();
      if (((_currTime.getTime() - this.lastLockCheck.getTime()) / 1000) > 60) {
        this.editSalesOrderLock();
      }
    }
  }

  changesFunc(_before, _after, _basicData) {
    let changes = [];
    let _a = JSON.parse(JSON.stringify(_after.getJson()));
    let _aa = this.flattenObject(_a);
    let _bb = this.flattenObject(_before);

    var keys = Object.keys(_bb);
    for (var i = 0; i < keys.length; i++) {
      // console.log("keys ",keys[i]);
      // console.log("keys type",typeof(keys[i]));

      var key = keys[i];
      if (_bb[key] != _aa[key]) {
        // console.log(key + " value changed from " + _bb[key] + " to " + _aa[key]);
        changes.push(key + " value changed from " + _bb[key] + " to " + _aa[key]);
      }

    }
    _basicData.push(_aa['salesOrdNo']);
    _basicData.push(_aa['subOrdNoId']);
    return changes;
  }


  flattenObject = (obj) => {
    const flattened = {}

    Object.keys(obj).forEach((key) => {

      if (typeof obj[key] === 'object' && obj[key] !== null) {
        Object.assign(flattened, this.flattenObject(obj[key]))
      }
      // else {
      //   if(key.includes("Token")== true){
      //     var _temp = obj[key]
      //     Object.keys(_temp).forEach((key1) => {
      //       var _tempKey = key.concat(".",key1)
      //       flattened[_tempKey] = _temp[key1]
      //     });
      // }
      else {
        flattened[key] = obj[key]
      }

      // }
    })

    return flattened
  }

  getExisitingDataSheetList(): Array<DatasheetNumbers> {
    this.DSList = this.soObj.dataSheetIP;
    let dsIdList: Array<string> = [];
    this.DSList.forEach((_ds: DataSheetIP) => {
      dsIdList.push(_ds.dataSheetId);
    });
    return this._dataService.datasheetNumbers.filter((_subOrdNum: DatasheetNumbers) => {
      return dsIdList.indexOf(_subOrdNum.datasheetNumbersId) >= 0;
    });
  }

  createNewDataSheetEvent(_evnt: any) {
    //{"selSubNumId":this.selectedSubNumId,"copySubNumId":this.selectedCopySubNumId}
    this.addNewDataSheet(_evnt.selSubNumId, _evnt.copySubNumId);
  }

  addNewDataSheet(_selectedDSNumId: string, _copyFromDSId: string) {
    this._dataService.openLoader();
    // if (_selectedDSNumId && _copyFromDSId && _copyFromDSId != "-1") {
    //   let _tmpSubOrderClone:DataSheetIP = this.soObj.getDataSheetCloneMainContent(_copyFromDSId);
    //   _tmpSubOrderClone.dataSheetId = _selectedDSNumId;
    //    this.soObj.addNewDS(_tmpSubOrderClone); 
    // }
    // else {
    this.soObj.addNewDS(SalesOrder.getEmptyDataSheetObj(_selectedDSNumId, _copyFromDSId, this._dataService.userName, this._dataService.userId));
    // }
    this._dataService.closeLoader();
  }
  get issoLockObtained(): boolean {
    return this.isLockObtained;
  }

}